"use client";

import React, { useMemo } from "react";
import { Divider } from "staysure-component-library";

import DashboardAllCoverLevels from "@/components/molecules/renewals/landing/middle-section/policy-details/policy-details-sections/dashboard-all-cover-levels/dashboard-all-cover-levels";
import { OptimizelyExperimentsEnum } from "@/config/app-constant";
import { BRAND_STAYSURE, PRODUCT, VARIANT_FLOW } from "@/constants";
import { PolicyDetailsAccordionType } from "@/schema/renewal-page/middle-panel.schema";

import Styles from "./policy-details-content.module.css";
import CoverLevel from "./policy-details-sections/cover-level/cover-level";
import CruiseCover from "./policy-details-sections/cruise-cover/cruise-cover";
import DocumentSection from "./policy-details-sections/document-section/document-section";
import LastYearPrice from "./policy-details-sections/last-year-price/last-year-price";
import PolicyStartDate from "./policy-details-sections/policy-start-date/policy-start-date";
import TravelRegion from "./policy-details-sections/travel-region/travel-region";

type PolicyDetailsContentType = {
  policyDetailsAccordionData: PolicyDetailsAccordionType;
};

function PolicyDetailsContent({
  policyDetailsAccordionData,
}: Readonly<PolicyDetailsContentType>) {
  const isAllCoverLevelVariant = useMemo(
    () =>
      typeof window !== "undefined" &&
      localStorage.getItem(
        OptimizelyExperimentsEnum.RENEWAL_DASHBOARD_ALL_COVER_LEVEL
      ) === VARIANT_FLOW &&
      PRODUCT === BRAND_STAYSURE,
    []
  );

  return (
    <div
      className={Styles.policy_details_styles}
      data-testid="policy-details-section-test-id"
    >
      <PolicyStartDate cmsData={policyDetailsAccordionData} />
      <Divider margin={12} color="#DCDCDC" />

      <LastYearPrice cmsData={policyDetailsAccordionData} />
      <Divider margin={12} color="#DCDCDC" />

      {isAllCoverLevelVariant ? (
        <DashboardAllCoverLevels cmsData={policyDetailsAccordionData} />
      ) : (
        <CoverLevel cmsData={policyDetailsAccordionData} />
      )}
      <Divider margin={12} color="#DCDCDC" />

      <TravelRegion cmsData={policyDetailsAccordionData} />
      <Divider margin={12} color="#DCDCDC" />

      <CruiseCover cmsData={policyDetailsAccordionData} />
      <Divider margin={12} color="#DCDCDC" />

      <DocumentSection cmsData={policyDetailsAccordionData} />
    </div>
  );
}

export default PolicyDetailsContent;
